/**
 * Guía: Parámetros.
 *
 * Contenido derivado del capítulo **06** del manual —§0 (el panel de perillas
 * y que aquí no se crea ni se elimina nada), §2 (el acceso más estrecho del
 * dashboard)— y del flujo F42.
 *
 * Los dos pasos que importan son el del alcance —esto afecta a todos los
 * países a la vez— y el de que una clave que el código consulta pero nadie
 * sembró no aparece aquí, que es lo que lleva a concluir que no es
 * configurable.
 */

import type { TourFlow } from '../types';

const PARAMETROS_PATH = '/settings';

export const c06Parametros: TourFlow = {
  id: 'admin.settings',
  chapter: '06',
  title: 'Parámetros',
  summary:
    'Las perillas de la plataforma: qué alcance tienen, cuánto tardan en verse y qué no se puede hacer aquí.',
  href: PARAMETROS_PATH,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Los números que el código consulta en marcha',
      body:
        'Radios de búsqueda, tamaños de página, porcentajes por defecto, topes y ' +
        'interruptores. En vez de estar escritos en el código, se leen de aquí — y por eso ' +
        'se pueden cambiar sin publicar nada.',
      route: PARAMETROS_PATH,
    },
    {
      id: 'global-scope',
      title: 'Esto afecta a todos los países a la vez',
      body:
        'No hay parámetros por país en esta pantalla. Si lo que quieres cambiar es de un ' +
        'mercado concreto —impuestos, tarifas, pasarelas, puntos—, vive en Ajustes del ' +
        'País. Tocar una perilla global para arreglar un caso se lo cambia a los demás.',
      target: 'admin.settings.groups',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'no-create-no-delete',
      title: 'Aquí no se crea ni se elimina nada',
      body:
        'El catálogo lo define el código: la pantalla sólo cambia el valor de lo que ya ' +
        'existe y lo restaura a su valor de origen. Si el código consulta una clave que ' +
        'nadie sembró, no aparece — y eso no significa que no sea configurable.',
    },
    {
      id: 'limits',
      title: 'Cada perilla conoce sus límites',
      body:
        'Tipo, rango y unidad. Un valor fuera de banda se rechaza antes de guardarse, y un ' +
        'salto grande pide confirmación. No es burocracia: es lo único que separa un dedo ' +
        'de más de un cambio en producción.',
    },
    {
      id: 'five-minutes',
      title: 'Tarda hasta cinco minutos en verse',
      body:
        'El cambio se propaga solo. Si a los cinco minutos no surte efecto, entonces sí hay ' +
        'algo que mirar. Y todo cambio queda registrado con quién lo hizo y desde qué valor.',
    },
  ],
};
